export const team = {
  english: {
    team: 'The Team',
    coreTeam: 'CORE TEAM',
    coreTeamDetail:
      'Since the inception of the project in October 2018, over 127 individuals have been contacted for work (full time, part time, or contract), review, and consultation. 18 of these are part of the team, another 42 are engaged in varying capacities.',
    strategicLabel: 'STRATEGIC ADVISORS',
    projectTeamLabel: 'PROJECT TEAM',
  },
  panjabi: {
    team: 'ਟੀਮ',
    coreTeam: 'ਕੋਰ ਟੀਮ',
    coreTeamDetail:
      'ਅਕਤੂਬਰ ੨੦੧੮ ਵਿਚ ਪ੍ਰਾਜੈਕਟ ਦੀ ਸ਼ੁਰੂਆਤ ਤੋਂ ਬਾਅਦ, ਤਕਰੀਬਨ ੧੨੭ ਵਿਅਕਤੀਆਂ ਨਾਲ ਕਾਰਜ (ਫੁਲ ਟਾਈਮ, ਪਾਰਟ ਟਾਈਮ ਜਾਂ ਕੰਟ੍ਰੈਕਟ), ਸਮੀਖਿਆ ਅਤੇ ਸਲਾਹ ਲਈ ਸੰਪਰਕ ਕੀਤਾ ਗਿਆ। ਇਨ੍ਹਾਂ ਵਿਚੋਂ ੧੮ ਟੀਮ ਦਾ ਹਿੱਸਾ ਹਨ ਅਤੇ ਹੋਰ ੪੨ ਵਖੋ-ਵਖ ਸਮਰਥਾ ਵਿਚ ਜੁੜੇ ਹੋਏ ਹਨ।',
    strategicLabel: 'ਕਾਰਜਨੀਤਕ ਸਲਾਹਕਾਰ',
    projectTeamLabel: 'ਪ੍ਰਾਜੈਕਟ ਟੀਮ'
  },
};
